import React from 'react';
import './Spinner.pcss';

export interface Props {
  width?: string;
  height?: string;
}

const Spinner = ({ width, height }: Props) => {
  return (
    <div className="Spinner" data-testid="spinner">
      <img
        src="/images/loading-spinner.gif"
        style={{
          width,
          height,
        }}
      />
    </div>
  );
};

export default React.memo(Spinner);
